export function defined(d) {
  return d !== undefined && d !== null && !Number.isNaN(d);
}
/**
 * Filter data by specified fields and filter callback for each fields.
 * It saves datum with every fields defined by default.
 */
export var Filter = function Filter(options) {
  var _options$callback = options.callback,
    callback = _options$callback === void 0 ? defined : _options$callback;
  return function (data) {
    return data.filter(callback);
  };
};
Filter.props = {};